import React, { SyntheticEvent } from "react";
import clsx from "clsx";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import SnackbarContent from "@mui/material/SnackbarContent";
import WarningIcon from "@mui/icons-material/Warning";
import { theme } from "../utils/theme";
//import {makeStyles} from '@mui/styles/makeStyles'; 
import { LED_COLORS } from "../utils/colors";

/* TODO: Themes come back here - all bad makeStyles/styled/etc*/

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

//const useNotificationStyle = makeStyles((theme: Theme) => ({
  const success = {
    backgroundColor: LED_COLORS.OK.BACKGROUND.ENABLED,
    color: LED_COLORS.ERROR.FONT.ENABLED
  };
  const error = {
    backgroundColor: LED_COLORS.ERROR.BACKGROUND.ENABLED,
    color: LED_COLORS.ERROR.FONT.ENABLED
  };
  const info = {
    backgroundColor: LED_COLORS.OK.BACKGROUND.ENABLED,
    color: LED_COLORS.OK.FONT.ENABLED
  };
  const warning = {
    backgroundColor: LED_COLORS.WARNING.BACKGROUND.ENABLED,
    color: LED_COLORS.OK.FONT.ENABLED
  };
  const icon = {
    fontSize: 20
  };
  const iconVariant = {
    opacity: 0.9,
    marginRight: theme.spacing(1)
  };
  const message = {
    display: "flex",
    alignItems: "left"
  };

interface INotificationContentProps {
  message: string;
  onClose?: () => void;
  variant: keyof typeof variantIcon;
  style: any
}

function NotificationContent(props: INotificationContentProps): React.ReactElement {
  const { style, message, onClose, variant } = props;
  const Icon = variantIcon[variant];
  const classNames = /* TODO: Themes */
    variant === "success"
      ? success
      : variant === "warning"
      ? warning
      : error;
  return (
    <SnackbarContent
      data-cy="notification-popup"
      style={style}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={style}>
          <Icon style={{...icon, ...iconVariant}}/>
          {message}
        </span>
      }
      action={[
        <IconButton
          data-cy="notification-close-button"
          key="close"
          aria-label="close"
          color="inherit"
          onClick={onClose}
          size="large">
          <CloseIcon style={icon} /> 
        </IconButton>
      ]}
    />
  );
}

export interface INotificationProps {
  className: string;
  message: string;
}

const margin = {
  margin: theme.spacing(1)
}
export function Notification(notificationProps: INotificationProps): React.ReactElement {
  const [open, setOpen] = React.useState(true);

  const handleClose = (event?: SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(!open);
  };
  //const classes = useStylesWrapper();
  const variant: any =
    notificationProps.className === "error" ? "error" : notificationProps.className === "warning" ? "warning" : "success";

  return (
       <NotificationContent onClose={handleClose} variant={variant} message={notificationProps.message} style={margin} />

  );
}
